import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Button } from '../Button/Button';
import { Modal } from '../Modal/Modal';
import { Stack } from '../Stack/Stack';
import { Text } from '../Typography';

export type TimezoneChangeModalProps = {
	open: boolean;
	computerTimezone: string;
	profileTimezone: string;
	onConfirm: () => void;
};

export const TimezoneChangeModal: FC<TimezoneChangeModalProps> = ({
	open,
	computerTimezone,
	profileTimezone,
	onConfirm,
}) => {
	const { t } = useTranslation('timezone-change-modal');

	// Modal ignores `open`; callers must unmount when closed (useModal / conditional render).
	if (!open) return null;

	return (
		<Modal
			open
			size="medium"
			closeOnEsc={false}
			header={<Modal.Header>{t('title')}</Modal.Header>}
			footer={
				<Modal.Footer>
					<Button variation="primary" onClick={onConfirm}>
						{t('footer.ok')}
					</Button>
				</Modal.Footer>
			}
		>
			<Modal.Body>
				<Modal.Section>
					<Stack spacing="loose" vertical>
						<Text>
							<Trans
								ns="timezone-change-modal"
								i18nKey="body.notice"
								values={{ computerTimezone, profileTimezone }}
								components={{ strong: <strong /> }}
							/>
						</Text>
						<Text>
							<Trans
								ns="timezone-change-modal"
								i18nKey="body.update"
								values={{ computerTimezone }}
								components={{ strong: <strong /> }}
							/>
						</Text>
					</Stack>
				</Modal.Section>
			</Modal.Body>
		</Modal>
	);
};
